import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Placement } from '@popperjs/core';
@Component({
  selector: 'app-progress-card',
  templateUrl: './progress-card.component.html'
})
export class ProgressCardComponent implements OnInit {
  sizeList = ['small', 'large'];
  statusList = ['default', 'primary', 'success', 'warning', 'danger', 'normal', 'active'];
  selectedSize = 'small';
  selectedStatus = 'default';
  hasCloseButton = false;
  hasOutline = true;
  disabled = false;
  hasStatusIcon = false;
  icon = '';
  ariaLabel = 'Chips';
  hasContentBelow = false;
  hasDefaultExpanded = true;
  hasIconLeftSide = false;
  hasActions = true;
  defaultCollapseLabel = 'Collapse';
  DefaultexpandLabel = 'Expand';
  listcollapseLabel = 'Show more';
  listexpandLabel = 'Hide';
  toggleNgModel: boolean = true;
  creditCard = 'Credit Card';
  futureSimple = 'Future Simple'
  creditCard1 = 'Credit Card1';
  futureSimple1 = 'Future Simple1'
  nextIconClass = 'icon-link-external';
  link1: { label: string, hyperLink: string, target: string } = { label: 'Link label', hyperLink: 'https://www.macmillaneducationeverywhere.com/terms-conditions/', target: '_blank' };
  selectedPlacement: Placement = 'auto';
  selectedLanguage: string = 'English';
  hasCaret: boolean = true;
  message: string = 'Progress card info';
  isBrowser: boolean;
  hasMeeLogo = true as boolean;
  hasAccordianCard = true as boolean;
  hasTooltip = true as boolean;
  hasLableIcon = true as boolean;
  hasViewButton = true as boolean;
  hasMetaData = true as boolean;
  isMobileView = false as boolean;
  isDesktopView = true as boolean;
  preview = `
  <div class="c-progress-card__skil-block-block">    
  <ul class="c-progress-card__skil-block-list" role="list">
      <li class="c-progress-card__skil-block-list-item" role="listitem">
          <span class="c-progress-card__skil-block-list-item-name">Reading</span>
          <span class="c-progress-card__skil-block-list-item-score">70%</span>
      </li>
      <li class="c-progress-card__skil-block-list-item" role="listitem">
          <span class="c-progress-card__skil-block-list-item-name">Writing</span>
          <span class="c-progress-card__skil-block-list-item-score">60%</span>
      </li>
      <li class="c-progress-card__skil-block-list-item" role="listitem">
          <span class="c-progress-card__skil-block-list-item-name">Word Formation</span>
          <span class="c-progress-card__skil-block-list-item-score">50%</span>
      </li>
      <li class="c-progress-card__skil-block-list-item" role="listitem">
          <span class="c-progress-card__skil-block-list-item-name">Reading</span>
          <span class="c-progress-card__skil-block-list-item-score">70%</span>
      </li>
      <li class="c-progress-card__skil-block-list-item" role="listitem">
          <span class="c-progress-card__skil-block-list-item-name">Writing</span>
          <span class="c-progress-card__skil-block-list-item-score">60%</span>
      </li>
      <li class="c-progress-card__skil-block-list-item" role="listitem">
          <span class="c-progress-card__skil-block-list-item-name">Word Formation</span>
          <span class="c-progress-card__skil-block-list-item-score">50%</span>
      </li>
  </ul>
</div>
  `;
  label = 'Language Hub';
  buttonId = 'buttonId';
  tooltipId = 'tooltipId';
  metaData = [
    {label : 'Level',
     value : 'Level 0'},
     {label : 'Classes',
     value : '2'},
     {label : 'Students',
     value : '3'}
  ]
  

  constructor(@Inject(PLATFORM_ID) public platformId:object) { 
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else{
      this.isBrowser = false;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth < 768) {
        this.hasDefaultExpanded = false;
        this.isMobileView = true;
        this.isDesktopView = false;
      } else{
        this.isMobileView = false;
        this.isDesktopView = true;
      }
    }
  }
  ngOnInit(): void {
    this.onResize();
  }
}